var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TagsToChart',{staticClass:"companies",attrs:{"data":_vm.companies,"height":3000}})
}
var staticRenderFns = []

export { render, staticRenderFns }